// 9fbef606107a605d69c0edbcd8029e5d
const NewCouponCardConstant = {
  PLCC_USER: 'PLCC',
  PLCB: 'PLCB',
  TRUE: 'true',
  APPLYING: 'applying',
  REMOVING: 'removing',
};

export default NewCouponCardConstant;
